import { Phone, CalendarClock } from "lucide-react";
import { COMPANY } from "@/data/content";

export default function StickyMobileBar() {
  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-white border-t border-border card-shadow"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="sticky-mobile-bar"
    >
      <div className="grid grid-cols-2 gap-2 p-2.5">
        <a
          href={`tel:${COMPANY.phoneHref}`}
          data-testid="sticky-bar-call-button"
          className="flex items-center justify-center gap-2 min-h-[52px] rounded-xl bg-[color:var(--brand-green)] text-white font-bold text-base"
        >
          <Phone className="h-5 w-5" /> Anrufen
        </a>
        <a
          href="#kontakt"
          data-testid="sticky-bar-callback-button"
          className="flex items-center justify-center gap-2 min-h-[52px] rounded-xl bg-white border-2 border-[color:var(--brand-navy)] text-[color:var(--brand-navy)] font-bold text-base"
        >
          <CalendarClock className="h-5 w-5" /> Rückruf
        </a>
      </div>
    </div>
  );
}
